import _regenerator from "/usr/app/node_modules/@babel/runtime/helpers/esm/regenerator.js";
import _objectSpread from "/usr/app/node_modules/@babel/runtime/helpers/esm/objectSpread2.js";
import _asyncToGenerator from "/usr/app/node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js";
import React from "react";
var __jsx = React.createElement;
import { useTranslation } from "@i18n";
import stl from "./PaymentInfo.module.css";
import PriceDetailsShimmer from "@/pages/checkout/components/PaymentInfo/PriceDetailsShimmer";
import { CDN_LINK } from "@globalConfig";
import SAR from "@componentsShared/SAR/SAR";
import ExpandableWarrantySelector from "@/pages/checkout/components/PaymentInfo/ExpandableWarrantySelector";
import { trackEvents } from "@/common/events/events";
import { useSession } from "@/_MiniApps/auth/AuthContext";
import { twMerge } from "tailwind-merge";
import { REFERRER_REWARD_TYPE } from "@/pages/checkout/constants";
import WarrantyCollapsedHeader from "@/pages/checkout/components/PaymentInfo/WarrantyCollapsedHeader";
var PaymentInfo = function PaymentInfo(props) {
  var _checkoutOrder$regist, _checkoutOrder$shippi, _checkoutOrder$warran, _checkoutOrder$warran2, _checkoutOrder$roadSe, _checkoutOrder$roadSe2;
  var _props$showOrderNumbe = props.showOrderNumber,
    showOrderNumber = _props$showOrderNumbe === void 0 ? true : _props$showOrderNumbe;
  var _useTranslation = useTranslation(),
    t = _useTranslation.t,
    tShort = _useTranslation.tShort;
  var _useSession = useSession(),
    user = _useSession.user;
  var _ref = props || {},
    checkoutOrder = _ref.checkoutOrder,
    hideData = _ref.hideData,
    isFinance = _ref.isFinance,
    showRemainingData = _ref.showRemainingData,
    onClickInfoIcon = _ref.onClickInfoIcon,
    referralData = _ref.referralData,
    _ref$orderType = _ref.orderType,
    orderType = _ref$orderType === void 0 ? 'cash' : _ref$orderType,
    _ref$warrantyReferral = _ref.warrantyReferralLocation,
    warrantyReferralLocation = _ref$warrantyReferral === void 0 ? 'checkout' : _ref$warrantyReferral,
    _ref$showWarrantyWidg = _ref.showWarrantyWidget,
    showWarrantyWidget = _ref$showWarrantyWidg === void 0 ? false : _ref$showWarrantyWidg,
    onWarrantySelected = _ref.onWarrantySelected;
  var warrantyEventBase = {
    order_id: checkoutOrder === null || checkoutOrder === void 0 ? void 0 : checkoutOrder.id,
    referral_location: warrantyReferralLocation,
    order_type: orderType
  };
  var warranty_promo_code = (referralData === null || referralData === void 0 ? void 0 : referralData.type) === REFERRER_REWARD_TYPE.WARRANTY;
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("div", {
    id: "checkout-payment-info-container",
    className: [stl.container, props.className ? props.className : ""].join(" ")
  }, props.loading ? /*#__PURE__*/React.createElement(PriceDetailsShimmer, null) : /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("div", {
    className: stl.ImageName
  }, /*#__PURE__*/React.createElement("div", {
    className: stl.imgContainer
  }, /*#__PURE__*/React.createElement("img", {
    src: checkoutOrder === null || checkoutOrder === void 0 ? void 0 : checkoutOrder.post_image
  })), /*#__PURE__*/React.createElement("div", {
    id: "checkout-payment-title-container",
    className: stl.titleContainer
  }, isFinance && /*#__PURE__*/React.createElement("p", {
    id: "checkout-payment-finance-label",
    className: "m-hide"
  }, t("value_additional_services", {
    ns: "web_checkout_cash"
  })), /*#__PURE__*/React.createElement("strong", {
    id: "checkout-payment-car-title"
  }, checkoutOrder ? checkoutOrder.post_title : null))), /*#__PURE__*/React.createElement("div", {
    id: "checkout-payment-row",
    className: stl.genralInfo
  }, showOrderNumber && !isFinance && !showRemainingData && (checkoutOrder === null || checkoutOrder === void 0 ? void 0 : checkoutOrder.id) && /*#__PURE__*/React.createElement("div", {
    className: stl.flxMeS
  }, /*#__PURE__*/React.createElement("strong", {
    className: stl.label
  }, " ", t("order", {
    ns: "web_checkout_cash"
  })), /*#__PURE__*/React.createElement("strong", {
    id: "payment-info_order-id",
    className: stl.orderId
  }, checkoutOrder === null || checkoutOrder === void 0 ? void 0 : checkoutOrder.id)), ((checkoutOrder === null || checkoutOrder === void 0 ? void 0 : checkoutOrder.post_price) || (checkoutOrder === null || checkoutOrder === void 0 ? void 0 : checkoutOrder.post_price) == 0) && /*#__PURE__*/React.createElement("div", {
    id: "checkout-car-price-row",
    className: stl.flx
  }, /*#__PURE__*/React.createElement("span", null, t("car_price", {
    ns: "web_checkout_cash"
  })), /*#__PURE__*/React.createElement("strong", {
    id: "checkout-car-price"
  }, checkoutOrder ? checkoutOrder.post_price : "", /*#__PURE__*/React.createElement("span", {
    className: "text-xl"
  }, /*#__PURE__*/React.createElement(SAR, null))), (checkoutOrder === null || checkoutOrder === void 0 ? void 0 : checkoutOrder.post_is_new) == 0 && /*#__PURE__*/React.createElement("p", null, t("price_includes_vat", {
    ns: "web_checkout_cash"
  })), (checkoutOrder === null || checkoutOrder === void 0 ? void 0 : checkoutOrder.limited_quantity) && /*#__PURE__*/React.createElement("p", null, t("price_change_depending_car_availability", {
    ns: "web_checkout_cash"
  }))), !isFinance ? /*#__PURE__*/React.createElement("div", {
    className: stl.flx
  }, /*#__PURE__*/React.createElement("span", null, t("value_added_tax_services", {
    ns: "web_checkout_cash"
  })), /*#__PURE__*/React.createElement("strong", {
    id: "payment-info_vat-price"
  }, checkoutOrder ? checkoutOrder.vat : "", /*#__PURE__*/React.createElement("span", {
    className: "text-xl"
  }, /*#__PURE__*/React.createElement(SAR, null))), /*#__PURE__*/React.createElement("p", null, t("percentage_value_added_subject_change", {
    ns: "web_checkout_cash"
  }))) : null, ((checkoutOrder === null || checkoutOrder === void 0 ? void 0 : checkoutOrder.registration_fees) || (checkoutOrder === null || checkoutOrder === void 0 ? void 0 : checkoutOrder.registration_fees) == 0) && /*#__PURE__*/React.createElement("div", {
    className: stl.flx
  }, checkoutOrder !== null && checkoutOrder !== void 0 && checkoutOrder.post_is_new ? /*#__PURE__*/React.createElement("span", null, t("registration_plates", {
    ns: "web_checkout_cash"
  })) : /*#__PURE__*/React.createElement("span", null, t("ownership_transfer", {
    ns: "web_checkout_cash"
  })), /*#__PURE__*/React.createElement("strong", {
    id: "payment-info_registration-fees"
  }, checkoutOrder ? parseInt(checkoutOrder.registration_fees) > 0 ? /*#__PURE__*/React.createElement(React.Fragment, null, checkoutOrder.registration_fees, " ", /*#__PURE__*/React.createElement("span", {
    className: "text-xl"
  }, /*#__PURE__*/React.createElement(SAR, null))) : /*#__PURE__*/React.createElement("div", {
    id: "checkout-ownership-free-tag",
    className: stl.freeTag
  }, t("free", {
    ns: "web_checkout_cash"
  }), /*#__PURE__*/React.createElement("div", {
    id: "checkout-old-price",
    className: stl.oldPrice
  }, checkoutOrder === null || checkoutOrder === void 0 ? void 0 : (_checkoutOrder$regist = checkoutOrder.registrationPriceDetails) === null || _checkoutOrder$regist === void 0 ? void 0 : _checkoutOrder$regist.oldPrice, " ", /*#__PURE__*/React.createElement(SAR, null))) : null)), ((checkoutOrder === null || checkoutOrder === void 0 ? void 0 : checkoutOrder.shipping_fees) || (checkoutOrder === null || checkoutOrder === void 0 ? void 0 : checkoutOrder.shipping_fees) == 0) && /*#__PURE__*/React.createElement("div", {
    className: stl.flx
  }, /*#__PURE__*/React.createElement("span", null, t("shipping_cost", {
    ns: "web_checkout_cash"
  })), (checkoutOrder === null || checkoutOrder === void 0 ? void 0 : checkoutOrder.shipping_fees_show_note) && /*#__PURE__*/React.createElement("div", {
    className: "flex gap-[9px] w-[150px] items-center justify-end cursor-pointer hasEvents",
    onClick: function onClick() {
      onClickInfoIcon && onClickInfoIcon();
    }
  }, /*#__PURE__*/React.createElement("strong", {
    id: "checkout-shipping-cost-value",
    className: "text-[#6D7A8D] text-sm font-bold leading-6 "
  }, t("determined", {
    ns: "web_checkout_cash"
  })), /*#__PURE__*/React.createElement("img", {
    className: "hasEvents cursor-pointer",
    src: CDN_LINK + "/assets/images/Vector.svg",
    alt: "icon"
  })), !(checkoutOrder !== null && checkoutOrder !== void 0 && checkoutOrder.shipping_fees_show_note) && /*#__PURE__*/React.createElement("strong", {
    id: "checkout-shipping-cost-value"
  }, checkoutOrder ? parseInt(checkoutOrder.shipping_fees) > 0 ? /*#__PURE__*/React.createElement(React.Fragment, null, checkoutOrder.shipping_fees, " ", /*#__PURE__*/React.createElement("span", {
    className: "text-xl"
  }, /*#__PURE__*/React.createElement(SAR, null))) : /*#__PURE__*/React.createElement("div", {
    id: "checkout-free-tag",
    className: stl.freeTag
  }, t("free", {
    ns: "web_checkout_cash"
  }), /*#__PURE__*/React.createElement("div", {
    className: stl.oldPrice
  }, checkoutOrder === null || checkoutOrder === void 0 ? void 0 : (_checkoutOrder$shippi = checkoutOrder.shippingPriceDetails) === null || _checkoutOrder$shippi === void 0 ? void 0 : _checkoutOrder$shippi.oldPrice, " ", /*#__PURE__*/React.createElement(SAR, null))) : null)), (checkoutOrder === null || checkoutOrder === void 0 ? void 0 : checkoutOrder.coupon_fees) && /*#__PURE__*/React.createElement("div", {
    className: stl.flx
  }, /*#__PURE__*/React.createElement("span", null, tShort("post_info/coupon_fees", {
    ns: "web_tracking"
  })), /*#__PURE__*/React.createElement("strong", null, checkoutOrder.coupon_fees, " ", /*#__PURE__*/React.createElement("span", {
    className: "text-xl"
  }, /*#__PURE__*/React.createElement(SAR, null)))), showWarrantyWidget && (checkoutOrder !== null && checkoutOrder !== void 0 && checkoutOrder.warrantyPriceDetailsV3 || checkoutOrder !== null && checkoutOrder !== void 0 && (_checkoutOrder$warran = checkoutOrder.warrantyV2) !== null && _checkoutOrder$warran !== void 0 && (_checkoutOrder$warran2 = _checkoutOrder$warran.items) !== null && _checkoutOrder$warran2 !== void 0 && _checkoutOrder$warran2.length) ? /*#__PURE__*/React.createElement("div", {
    className: twMerge("my-2 md:mb-5")
  }, /*#__PURE__*/React.createElement(ExpandableWarrantySelector, {
    warranty_promo_code: warranty_promo_code,
    warrantyPriceDetails: checkoutOrder === null || checkoutOrder === void 0 ? void 0 : checkoutOrder.warrantyPriceDetailsV3,
    warrantyData: checkoutOrder === null || checkoutOrder === void 0 ? void 0 : checkoutOrder.warrantyV2,
    onListOpened: function onListOpened() {
      return trackEvents('warranty_list_opened', warrantyEventBase);
    },
    onWarrantySelected: (/*#__PURE__*/function () {
      var _ref2 = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee(id) {
        var _checkoutOrder$warran3, _checkoutOrder$warran4, _checkoutOrder$warran5;
        var years;
        return _regenerator().w(function (_context) {
          while (1) switch (_context.n) {
            case 0:
              years = checkoutOrder === null || checkoutOrder === void 0 ? void 0 : (_checkoutOrder$warran3 = checkoutOrder.warrantyV2) === null || _checkoutOrder$warran3 === void 0 ? void 0 : (_checkoutOrder$warran4 = _checkoutOrder$warran3.items) === null || _checkoutOrder$warran4 === void 0 ? void 0 : (_checkoutOrder$warran5 = _checkoutOrder$warran4.find(function (ele) {
                return (ele === null || ele === void 0 ? void 0 : ele.id) == id;
              })) === null || _checkoutOrder$warran5 === void 0 ? void 0 : _checkoutOrder$warran5.years;
              _context.n = 1;
              return onWarrantySelected === null || onWarrantySelected === void 0 ? void 0 : onWarrantySelected(id);
            case 1:
              trackEvents('warranty_selected', _objectSpread(_objectSpread({}, warrantyEventBase), {}, {
                selected_warranty: years
              }));
            case 2:
              return _context.a(2);
          }
        }, _callee);
      }));
      return function (_x) {
        return _ref2.apply(this, arguments);
      };
    }())
  })) : (checkoutOrder === null || checkoutOrder === void 0 ? void 0 : checkoutOrder.warrantyPriceDetailsV3) && /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("div", {
    className: "my-2 me-2"
  }, /*#__PURE__*/React.createElement(WarrantyCollapsedHeader, {
    warrantyPriceDetails: checkoutOrder.warrantyPriceDetailsV3
  }))), (checkoutOrder === null || checkoutOrder === void 0 ? void 0 : checkoutOrder.roadService) && Object.keys(checkoutOrder.roadService).length > 0 && /*#__PURE__*/React.createElement("div", {
    className: stl.flx
  }, /*#__PURE__*/React.createElement("span", null, checkoutOrder.roadService.name, /*#__PURE__*/React.createElement("p", {
    className: stl.smlNotesss
  }, " ", checkoutOrder.roadService.text, " ")), /*#__PURE__*/React.createElement("strong", {
    className: stl.freeTag
  }, checkoutOrder.roadService.old_price && /*#__PURE__*/React.createElement("span", {
    className: stl.oldPrice
  }, checkoutOrder.roadService.old_price, /*#__PURE__*/React.createElement(SAR, null), " "), checkoutOrder.roadService.price == "0" ? /*#__PURE__*/React.createElement("div", {
    className: stl.freeTag
  }, t("free", {
    ns: "web_checkout_cash"
  }), /*#__PURE__*/React.createElement("div", {
    className: stl.oldPrice
  }, checkoutOrder && (checkoutOrder === null || checkoutOrder === void 0 ? void 0 : checkoutOrder.roadServicePriceDetail) && (checkoutOrder === null || checkoutOrder === void 0 ? void 0 : (_checkoutOrder$roadSe = checkoutOrder.roadServicePriceDetail) === null || _checkoutOrder$roadSe === void 0 ? void 0 : _checkoutOrder$roadSe.oldPrice) && (checkoutOrder === null || checkoutOrder === void 0 ? void 0 : (_checkoutOrder$roadSe2 = checkoutOrder.roadServicePriceDetail) === null || _checkoutOrder$roadSe2 === void 0 ? void 0 : _checkoutOrder$roadSe2.oldPrice), " ", /*#__PURE__*/React.createElement(SAR, null))) : checkoutOrder.roadService.price)), checkoutOrder !== null && checkoutOrder !== void 0 && checkoutOrder.referral_discount && checkoutOrder.referral_discount != 0 ? /*#__PURE__*/React.createElement("div", {
    id: "checkout-discount-row",
    className: [stl.flx, stl.ArboonRow, stl.discount].join(" ")
  }, /*#__PURE__*/React.createElement("span", null, t("additional_discount_code", {
    ns: "web_checkout_cash"
  }), " ", "(", checkoutOrder.referral_code, ")"), /*#__PURE__*/React.createElement("strong", {
    id: "checkout-additional-discount-value"
  }, checkoutOrder.referral_discount, /*#__PURE__*/React.createElement("span", null, /*#__PURE__*/React.createElement(SAR, null)))) : null, checkoutOrder !== null && checkoutOrder !== void 0 && checkoutOrder.service_amount || (checkoutOrder === null || checkoutOrder === void 0 ? void 0 : checkoutOrder.service_amount) == 0 ? /*#__PURE__*/React.createElement("div", {
    className: stl.flx
  }, /*#__PURE__*/React.createElement("span", null, t("value_additional_services_2", {
    ns: "web_checkout_cash"
  })), /*#__PURE__*/React.createElement("strong", null, checkoutOrder ? checkoutOrder.service_amount : "", /*#__PURE__*/React.createElement(SAR, null))) : null, checkoutOrder !== null && checkoutOrder !== void 0 && checkoutOrder.vas_amount || (checkoutOrder === null || checkoutOrder === void 0 ? void 0 : checkoutOrder.vas_amount) == 0 ? /*#__PURE__*/React.createElement("div", {
    className: stl.flx
  }, /*#__PURE__*/React.createElement("span", null, t("value_added_tax", {
    ns: "web_checkout_cash"
  })), /*#__PURE__*/React.createElement("strong", null, checkoutOrder ? checkoutOrder.vas_amount : "", /*#__PURE__*/React.createElement(SAR, null)), /*#__PURE__*/React.createElement("p", null, t("percentage_value_added_subject_change", {
    ns: "web_checkout_cash"
  }))) : null, !showRemainingData && /*#__PURE__*/React.createElement("div", {
    id: "precheckout-total-price",
    className: [stl.flx, stl.totalRow, isFinance ? stl.borderBottom : ""].join(" ")
  }, /*#__PURE__*/React.createElement("span", null, t("total_amount", {
    ns: "web_checkout_cash"
  })), /*#__PURE__*/React.createElement("strong", {
    id: "checkout-total-price"
  }, isFinance ? checkoutOrder === null || checkoutOrder === void 0 ? void 0 : checkoutOrder.total_amount : checkoutOrder === null || checkoutOrder === void 0 ? void 0 : checkoutOrder.total_price, /*#__PURE__*/React.createElement("span", {
    className: "!text-2xl"
  }, /*#__PURE__*/React.createElement(SAR, null)))), !hideData && /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("div", {
    className: [stl.flx, stl.ArboonRow].join(" ")
  }, /*#__PURE__*/React.createElement("div", {
    className: stl.colFlex
  }, /*#__PURE__*/React.createElement("span", null, t("down_payment", {
    ns: "web_checkout_cash"
  })), /*#__PURE__*/React.createElement("p", null, t("down_payment_fully_refundable_registration", {
    ns: "web_checkout_cash"
  }))), /*#__PURE__*/React.createElement("strong", {
    id: "payment-info_arboun-fees"
  }, checkoutOrder === null || checkoutOrder === void 0 ? void 0 : checkoutOrder.arboun, /*#__PURE__*/React.createElement("span", {
    className: "!text-2xl"
  }, /*#__PURE__*/React.createElement(SAR, null)), /*#__PURE__*/React.createElement("br", null), /*#__PURE__*/React.createElement("span", {
    className: stl.note
  }, t("refundable", {
    ns: "web_checkout_cash"
  }))))), showRemainingData && /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("div", {
    className: "".concat(stl.flx, " ").concat(stl.borderTop)
  }, /*#__PURE__*/React.createElement("span", null, t("down_payment", {
    ns: "web_checkout_cash"
  })), /*#__PURE__*/React.createElement("strong", null, checkoutOrder === null || checkoutOrder === void 0 ? void 0 : checkoutOrder.arboun, " -", /*#__PURE__*/React.createElement(SAR, null))), /*#__PURE__*/React.createElement("div", {
    className: stl.flx
  }, /*#__PURE__*/React.createElement("span", null, t("amount_paid", {
    ns: "web_checkout_cash"
  })), /*#__PURE__*/React.createElement("strong", null, checkoutOrder === null || checkoutOrder === void 0 ? void 0 : checkoutOrder.payed_amount, " -", /*#__PURE__*/React.createElement("span", {
    className: "text-2xl"
  }, /*#__PURE__*/React.createElement(SAR, null)))), /*#__PURE__*/React.createElement("div", {
    className: "".concat(stl.flx, " ").concat(stl.boldFlex)
  }, /*#__PURE__*/React.createElement("span", null, t("remaining_amount", {
    ns: "web_checkout_cash"
  })), /*#__PURE__*/React.createElement("strong", null, isFinance ? checkoutOrder === null || checkoutOrder === void 0 ? void 0 : checkoutOrder.remaining_amount : checkoutOrder === null || checkoutOrder === void 0 ? void 0 : checkoutOrder.remaining_price_payed, /*#__PURE__*/React.createElement("span", null, /*#__PURE__*/React.createElement(SAR, null)))))))));
};
export default PaymentInfo;